module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [_h('v-header', {
    attrs: {
      "seller": _vm.seller
    }
  }), " ", " ", _h('div', {
    staticClass: "tab border-1px"
  }, [_h('div', {
    staticClass: "tab-item"
  }, [_h('router-link', {
    attrs: {
      "to": '/goods'
    }
  }, ["\n        商品\n\n      "])]), " ", _h('div', {
    staticClass: "tab-item"
  }, [_h('router-link', {
    attrs: {
      "to": "/ratings"
    }
  }, ["\n        评论\n      "])]), " ", _h('div', {
    staticClass: "tab-item"
  }, [_h('router-link', {
    attrs: {
      "to": "/seller"
    }
  }, ["\n        商家\n      "])])]), " ", " ", _h('keep-alive', [_h('router-view', {
    attrs: {
      "seller": _vm.seller
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.vue-loader@10.0.2/lib/template-compiler.js?id=data-v-5175b507!./~/.vue-loader@10.0.2/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 46
// module chunks = 1